import { createReducer, on } from '@ngrx/store';
import { initialNavigationState } from './navigation_state';
import { navActivateNextStep, navBack, navFinishInstallation, navOpenManualInstall, navSetActiveStep, navUpdate } from './navigation_actions_creator';

export const navigationReducer = createReducer(
  initialNavigationState,
  on(navSetActiveStep, (state, action) => {
      let navigationItems = state.navigationItems.map(item => {
        if (item.active) {
          return {...item, active: false, isLastStep: false};
        }
        return {...item};
      }).map(item => {
        if (item.name === action.activeStep.name) {
          return {...item, active: true};
        }
        return {...item};
      });
    return {
      ...state,
      navigationItems
    };
  }),
  on(navActivateNextStep, (state, action) => ({
    ...state,
    navigationItems: state.navigationItems.map(item => {
      if (item.name === action.finishedStep.name) {
        return {...item, finished: true};
      }
      return {...item};
    })
  })),
  on(navUpdate, (state, action) => ({...state, navigationItems: action.payload})),
  on(navOpenManualInstall, (state) => ({
    ...state,
    navigationItems: state.navigationItems.map(item => {
      if (item.active) {
        return {...item, isLastStep: true};
      }
      return {...item};
    })
  })),
  on(navBack, (state) => ({
    ...state,
    navigationItems: state.navigationItems.map(item => {
      if (item.active) {
        return {...item, isLastStep: false};
      }
      return {...item};
    })
  })),
  on(navFinishInstallation, (state, action) => ({
    ...state,
    navigationItems: state.navigationItems.map(item => {
      if (item.name === action.finishedStep.name) {
        return {...item, finished: true};
      }
      return {...item};
    })
  })),
);


